<script lang="ts">
  import {isDirtySearch, isHaveNews, isShowSearchLoader} from '../../../../stores'
  import { _ } from 'svelte-i18n'

  import NoItemsBanner from '../../../../custom/NoItemsBanner.svelte'
</script>

{#if !$isShowSearchLoader && !$isHaveNews && !$isDirtySearch}
  <NoItemsBanner
    title="{$_('nothingToSeeHere')}"
    subtitle="{$_('contentComingSoon')}"
    background="/static/no-items.jpeg"
  />
{/if}